import { Checkbox } from "@chakra-ui/react";
import { useField } from "formik";
import FormikFieldError from "newui/components/ui/FormikFieldError";
import { ReactNode } from "react";

interface FormikCheckboxProps {
	name: string;
	checkmarkTop?: string;
	children?: ReactNode;
	initialValue?: boolean;
	label?: string;
	labelComponent?: ReactNode;
	noWarning?: boolean;
	testId?: string;
}

export const FormikAcceptTermsCheckbox: React.FC<FormikCheckboxProps> = ({
	name,
	label,
	labelComponent,
	children,
	noWarning = false,
	testId,
	initialValue,
}) => {
	const [field, meta] = useField<boolean>(name);

	return (
		<div className={`relative mb-2`}>
			<Checkbox
				name={field.name}
				isChecked={Boolean(field.value ?? initialValue)}
				onChange={field.onChange}
				onBlur={field.onBlur}
				data-testid={testId}
				isInvalid={meta.touched && Boolean(meta.error)}
				colorScheme="green"
				sx={{
					'& .chakra-checkbox__control': {
						borderRadius: '50%',
						borderWidth: '2px',
						borderColor: 'rgba(132, 146, 166, 0.5)',
						width: '21px',
						height: '21px',
						backgroundColor: 'white',
						_checked: {
							backgroundColor: 'white',
							borderColor: '#003CE9', // Mint/green color
							_hover: {
								backgroundColor: 'white',
								borderColor: '#003CE9',
							},
						},
						_hover: {
							backgroundColor: 'white',
						},
					},
					'& .chakra-checkbox__control[data-checked]': {
						'& svg': {
							color: '#003CE9', // Mint/green checkmark
						},
					},
				}}
			>
				<span className="text-gray-400 text-base font-['Roboto'] select-none cursor-pointer">
					{children || labelComponent || (
						label && <span dangerouslySetInnerHTML={{ __html: label }} />
					)}
				</span>
			</Checkbox>

			{!noWarning && <FormikFieldError meta={meta} />}
		</div>
	);
};